<template>
    <router-view :filterProducts="filterProducts" :filterCategories="filterCategories" />
</template>

<script>

    export default  {
        components: {
        },
        data() {
            return {
                filterProducts: {},
                filterCategories: {},
            }
        },
        name: 'Gallery',
        mounted() {
        },
        beforeMount() {
            this.filterProducts = this.$root.filterProducts;
            this.filterCategories = this.$root.filterCategories;
        },
    }
</script>